<template>
<div class="chapter">
<div class="inner_page">
<p class="indent"><a id="file_029">This may seem confusing now, but don’t worry. As you go through the projects, it will make much more sense. Just remember to use layers of wool rather than a large clump to get the best results. And by keeping the fibers loose at one end, the surface area of the attachment place is increased and makes for a more secure attachment.</a></p><a id="file_029">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_029.vue?7d647e7c